import type { FetchTasksResponseData } from 'gcs-common/clients/api/entities/tasks/tasks-api-helpers';
import type { FC } from 'react';
import styles from './styles.module.scss';

interface TaskTodoProps {
  task: FetchTasksResponseData['tasks'][number];
  clickAction: VoidFunction;
}

// TODO: REF Merge all task states?
const TaskTodo: FC<TaskTodoProps> = ({ task, clickAction }) => {
  return (
    <div className={styles.taskContent} onClick={clickAction} role="button" tabIndex={0}>
      <div>{task.description || ' '}</div>
    </div>
  );
};

export default TaskTodo;
